module.exports = {"id":"187415","name":"Vladimir Granat","rating":"72","photo":"./data/images/photos/4/187415.png","club":{"name":"Rubin Kazan","logo":"./data/images/clubs/RubinKazan.png"},"positions":["DC","DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VladimirGranat0.json
// module id = 4299
// module chunks = 0